import React from 'react';
import { Pagination } from '@xo-union/tk-ui-pagination';

export default class PaginationContainer extends React.Component {
  constructor(props){
    super(props);
  }

  renderLink = ({ pageData: { page }, pageLinkProps, }) => {
    const { queryParams, seoRankedKeys, fullPath } = this.props;
    var params = {};

    Object.entries(queryParams).filter(element => {
      if(seoRankedKeys.includes(element[0])) {
        return params[element[0]] = element[1];
      }
    });

    if(page > 1) {
      params["page"] = page;
    }

    var resultParams = Object.entries(params).map((obj)=> { return obj.join('=') }).join('&');
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */
    return <a href={resultParams.length ? `${fullPath}?${resultParams}` : fullPath} {...pageLinkProps} />
  };

  render() {
    const { activePage, totalPageCount } = this.props;

    return (
      <Pagination
        activePage={activePage}
        totalPageCount={totalPageCount}
        renderLink={this.renderLink}
      />
    );
  }
}
